export default __webpack_public_path__ + "static/media/marginalia-delivery.8baa316e.svg";